import * as React from "react";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { UitkSpacing } from "uitk-react-spacing";
import { Footer } from "@gc/global-components";
import { LazyLoad } from "../utility/LazyLoad/LazyLoad";

/**
 * Represents the component at the bottom of a Blossom page. It will either use
 * an HTML string (parsed to add UITK styles) from globalcontrols on mobile or the Bernie
 * footer if it is on desktop HTG/F pages
 */
export const FlexFooter = ({ context }: { context: ExtendedContextStore }) => {
  const pageType = context.searchContext.pageType;

  if (pageTypesWithNoFooter.includes(pageType)) {
    return null;
  }

  const isBexStorefrontPage =
    context.searchContext.pageType.indexOf("Storefront") > -1 && context.site.brand === "expedia";
  const isCometStorefrontPage =
    context.searchContext.pageType.indexOf("Storefront") > -1 &&
    (context.site.brand === "orbitz" || context.site.brand === "travelocity");

  const marqueeClass = isBexStorefrontPage
    ? "bex-homepage-module"
    : isCometStorefrontPage
    ? "comet-homepage-module"
    : "";

  return (
    <LazyLoad context={context}>
      <UitkSpacing padding={{ block: "three", inlinestart: "two", inlineend: "two" }}>
        <div>
          <Footer marqueeClass={marqueeClass} />
        </div>
      </UitkSpacing>
    </LazyLoad>
  );
};

const pageTypesWithNoFooter = ["Html-Sitemap"];
